function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoginHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Menu - History",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 12006"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.844 1.029a.975.975 0 0 0-.379-.775.992.992 0 0 0-.846-.178L3.085 1.46a1.474 1.474 0 0 0-1.116 1.43v10.936H.984a.984.984 0 1 0 0 1.969h8.86V1.029zM7.875 7.92c0 .544-.329.984-.738.984S6.4 8.464 6.4 7.92s.329-.984.738-.984.737.439.737.984zm2.953-3.937h2.953v2.171a5.45 5.45 0 0 1 1.477-.2c.166 0 .329.006.492.022V3.982a1.971 1.971 0 0 0-1.969-1.969h-2.953zm0 7.383a4.43 4.43 0 1 1 4.43 4.43 4.431 4.431 0 0 1-4.43-4.431zM15.75 8.4a.492.492 0 0 0-.984 0v2.969a.494.494 0 0 0 .492.492h2.477a.492.492 0 1 0 0-.984H15.75z",
    transform: "translate(2 3.954)",
    style: {
      fill: "#a9b0b3"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginHistory);
export default __webpack_public_path__ + "static/media/IconLoginHistory.90542e2eee9d04c18abd8614f04ac0c2.svg";
export { ForwardRef as ReactComponent };